<app-page-spinner [(show)]="loading"></app-page-spinner>

<div class="esf-main-layout esf-main-layout--has-header" #topOfPage *ngIf="!loading">
  <main class="esf-main-content esf-main-content--alternative -width-max -has-transition">
    <div class="esf-container">

      <ul class="esf-progress-indicator top-margin">
        <li class="esf-progress-indicator__step" [ngClass]="{'-is-complete': stepProcess > 1, '-is-current': stepProcess === 1}">
          <div class="esf-progress-indicator__item">
            <div class="esf-progress-indicator__count">
              <div class="esf-progress-indicator__count-inner">
                <div class="esf-progress-indicator__number">1</div>
              </div>
            </div>
          </div>
          <div class="esf-progress-indicator__item esf-progress-indicator__item--label">
            <span class="esf-progress-indicator__label" i18n='@@mergeCustomer.stepProcess.compare'>Compare</span>
          </div>
          <div class="esf-progress-indicator__item esf-progress-indicator__item--separator">
            <div class="esf-progress-indicator__separator"></div>
          </div>
        </li>
        <li class="esf-progress-indicator__step" [ngClass]="{'-is-complete': stepProcess > 2, '-is-current': stepProcess === 2}">
          <div class="esf-progress-indicator__item">
            <div class="esf-progress-indicator__count">
              <div class="esf-progress-indicator__count-inner">
                <div class="esf-progress-indicator__number">2</div>
              </div>
            </div>
          </div>
          <div class="esf-progress-indicator__item esf-progress-indicator__item--label">
            <span class="esf-progress-indicator__label" i18n='@@mergeCustomer.stepProcess.assemble'>Assemble</span>
          </div>
          <div class="esf-progress-indicator__item esf-progress-indicator__item--separator">
            <div class="esf-progress-indicator__separator"></div>
          </div>
        </li>
        <li class="esf-progress-indicator__step" [ngClass]="{'-is-current': stepProcess === 3}">
          <div class="esf-progress-indicator__item">
            <div class="esf-progress-indicator__count">
              <div class="esf-progress-indicator__count-inner">
                <div class="esf-progress-indicator__number">3</div>
              </div>
            </div>
          </div>
          <div class="esf-progress-indicator__item esf-progress-indicator__item--label">
            <span class="esf-progress-indicator__label" i18n='@@mergeCustomer.stepProcess.merge'>Merge</span>
          </div>
          <div class="esf-progress-indicator__item esf-progress-indicator__item--separator">
            <div class="esf-progress-indicator__separator"></div>
          </div>
        </li>
      </ul>


      <ng-container [ngSwitch]="stepProcess">
        <ng-container *ngSwitchCase="1">
          <app-compare-data [selectedClub]="selectedClub"
                            [countries]="countries"
                            [firstCustomerData]="firstCustomerData"
                            [secondCustomerData]="secondCustomerData">
          </app-compare-data>
        </ng-container>

        <ng-container *ngSwitchCase="2">
          <app-assemble-data class="triggered"
                             [selectedClub]="selectedClub"
                             [countries]="countries"
                             [firstCustomerData]="firstCustomerData"
                             [secondCustomerData]="secondCustomerData">
          </app-assemble-data>
        </ng-container>

        <ng-container *ngSwitchCase="3">
          <app-review-data [selectedClub]="selectedClub"
                           [countries]="countries">
          </app-review-data>
        </ng-container>
      </ng-container>

      <app-submit-row-buttons [submitButtonText]="stepProcess === 3 ? buttonsTranslations.i18nMerge : buttonsTranslations.i18nNext"
                              [spinnerName]="spinnerName"
                              [cancelButtonText]="buttonsTranslations.i18nBack"
                              (cancelButton)="goBack()"
                              (submitButton)="goNext()">
        <button *ngIf="isPotentialDuplicate && stepProcess === 1"
                class="esf-button esf-button--standard esf-button--outlined"
                style="margin-left: 10px"
                type="button"
                (click)="removePotentialDuplicates()">
          <span i18n="@@general.button.notDuplicates'">These are not duplicates</span>
        </button>
      </app-submit-row-buttons>

    </div>
  </main>
</div>
